export class ProductSold {

    id: any;
    product: any;
    price: any;
    priceTotal: any;
    quantity: number;
    item: number;
    desconto: any;

    constructor(id: any, product: any, price: any, priceTotal: any, quantity: number,item: number,desconto: any) {
        this.id = id;
        this.product = product;
        this.price = price;
        this.priceTotal = priceTotal;
        this.quantity = quantity;
        this.item = item;
        this.desconto = desconto;
    }
}